import React from 'react'
import Layout from './Layout'

const Roles = () => {
    return (
        <Layout></Layout>
    )
}

export default Roles